<script lang="ts">
  import { AcceleratorBatch, AccountRoles } from '$shared/lib';

  export let roles: string[] = [];
  export let batches: string[] = [];
  export let size: 'sm' | 'lg' = 'sm';

  // Which roles to display and their priority
  const rolePriority = [AccountRoles.ADMIN, AccountRoles.MENTOR, AccountRoles.MODERATOR];

  // Get the highest priority role
  $: filteredRoles = roles
    .filter((role) => rolePriority.includes(role as AccountRoles))
    .sort(
      (a, b) => rolePriority.indexOf(a as AccountRoles) - rolePriority.indexOf(b as AccountRoles),
    );

  // Combine roles and batches into a single array
  $: tags = [...filteredRoles, ...batches];

  function isBatch(tag: string): boolean {
    return Object.values(AcceleratorBatch).includes(tag as AcceleratorBatch);
  }
</script>

{#if tags.length > 0}
  {#each tags as tag}
    <div
      class="font-architekt flex h-full cursor-pointer items-center gap-x-2 rounded border px-1 py-[0.1rem] leading-4"
      class:mentor={tag == AccountRoles.MENTOR}
      class:moderator={tag == AccountRoles.MODERATOR}
      class:admin={tag == AccountRoles.ADMIN}
      class:batch={isBatch(tag)}
      class:text-sm={size == 'lg'}
      class:px-2={size == 'lg'}
      class:py-1={size == 'lg'}
      class:text-xs={size == 'sm'}
      class:px-1={size == 'sm'}
      class:py-[0.1rem]={size == 'sm'}
    >
      {tag}
    </div>
  {/each}
{/if}

<style lang="postcss">
  .mentor {
    @apply border-orange-dark-7 bg-orange-dark-1 text-orange-dark-11;
  }

  .moderator {
    @apply border-mint-dark-7 bg-mint-dark-1 text-mint-dark-11;
  }

  .admin {
    @apply border-indigo-dark-7 bg-indigo-dark-1 text-indigo-dark-11;
  }

  .batch {
    @apply border-red-dark-7 bg-red-dark-2 text-red-dark-11;
  }
</style>
